/**
 * Determines the active toolbar tab based on the current pathname
 * @param pathname - The current URL pathname
 * @returns The active tab value ('flight', 'hotel', 'offers', 'account')
 */
export const getActiveToolbarTab = (pathname: string): string => {
    // Remove locale prefix if present (e.g., /en/hotel -> /hotel)
    const pathWithoutLocale = pathname.replace(/^\/(en|ar)/, '')

    // Check for specific routes
    if (pathWithoutLocale.startsWith('/hotel')) {
        return 'hotel'
    }

    if (pathWithoutLocale.startsWith('/offers')) {
        return 'offers'
    }

    if (pathWithoutLocale.startsWith('/account')) {
        return 'account'
    }

    // Default to 'flight' for home page and flight-related pages
    return 'flight'
}
